export default "<iframe src=\"https://sistemas.oefa.gob.pe/mpv/#/tramite\" frameborder=\"0\" width=\"100%\" height=\"100%\"></iframe>"